import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { facePaint } from '../../../domain/theme/utils/facePaint';
import { theme } from '../../../domain/theme';
import { ContentPackageHeader } from './ContentPackageHeader';
import { ContentPackageDescription } from './ContentPackageDescription';

export const ContentPackageWrapper = ({
  backgroundColor,
  extraStyles,
  contentPackageHeader,
  contentPackageDescription,
  children,
  headerChildren,
  headerStyles,
  descriptionStyles,
  className,
  isTravelGuide
}) => {
  let colorStyle = '';
  switch (backgroundColor) {
    case 'black':
      colorStyle = `background-color: #222;
      color: #fff;`;
      break;
    case 'true_black':
      colorStyle = `background-color: #000;
      color: #fff;`;
      break;
    case 'gray':
      colorStyle = `background-color: #666;
        color: #000;`;
      break;
    default:
      colorStyle = `background-color: #fff;
      color: #000;`;
      break;
  }
  const styles = {
    content: css`
      content-visibility: auto;
      margin-bottom: 40px;
      ${colorStyle}
      width: 100%;
      clear: both;
      position: relative;
      z-index: ${theme.zIndex('base')};
      ${theme.mq.tablet} {
        ${contentPackageHeader && 'padding-bottom: 60px;'}
      }
      ${extraStyles};
    `,
    wrapper: css`
      ${!isTravelGuide && 'max-width: 1600px;'}
      margin: 0 auto;
    `
  };
  return (
    <div css={styles.content} className={className}>
      <div css={styles.wrapper}>
        {headerChildren}
        {contentPackageHeader && (
          <ContentPackageHeader
            header={contentPackageHeader}
            styles={headerStyles}
          />
        )}
        {contentPackageHeader && contentPackageDescription && (
          <ContentPackageDescription
            description={contentPackageDescription}
            styles={descriptionStyles}
          />
        )}
        {children}
      </div>
    </div>
  );
};
ContentPackageWrapper.defaultProps = {
  backgroundColor: 'black',
  extraStyles: css`
    ${facePaint({
      'contain-intrinsic-size': ['0 599px', '0 590px', '0 737px', '0 922px']
    })}
  `,
  contentPackageHeader: undefined,
  contentPackageDescription: undefined,
  headerChildren: undefined,
  headerStyles: undefined,
  descriptionStyles: undefined,
  className: '',
  isTravelGuide: false
};
ContentPackageWrapper.propTypes = {
  backgroundColor: PropTypes.string,
  extraStyles: PropTypes.objectOf(PropTypes.any),
  contentPackageHeader: PropTypes.string,
  contentPackageDescription: PropTypes.string,
  children: PropTypes.node.isRequired,
  headerChildren: PropTypes.node,
  headerStyles: PropTypes.objectOf(PropTypes.any),
  descriptionStyles: PropTypes.objectOf(PropTypes.any),
  className: PropTypes.string,
  isTravelGuide: PropTypes.bool
};
